// src/pages/products/SensorsPage.tsx
import React from 'react';
import { Button, Modal, Input, Tag } from 'antd';
import { SensorItem } from '../../types/ProductItems';
import SensorForm from '../../components/forms/SensorForm';
import SensorsTable from '../../components/tables/SensorsTable';
import { useProductManager } from '../../hooks/useProductManager';
import { STORE_NAMES } from '../../utils/db';

const SensorsPage: React.FC = () => {
  const [search, setSearch] = React.useState('');

  const {
    items: sensors,
    currentItem,
    setCurrentItem,
    isModalVisible,
    setIsModalVisible,
    addItem: handleAddSensors,
    deleteItem: handleDelete,
    exportToExcel,
  } = useProductManager<SensorItem>(STORE_NAMES.sensors);

  const handleEdit = (item: SensorItem) => {
    setCurrentItem(item);
    setIsModalVisible(true);
  };

  const filtered = React.useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return sensors;
    return sensors.filter(item =>
      [item.brand, item.partNumber, item.model, item.sensorType, item.original, String(item.price)]
        .filter(Boolean)
        .some(v => String(v).toLowerCase().includes(q))
    );
  }, [sensors, search]);

  const totalCount = sensors.length;
  const shownCount = filtered.length;

  return (
    <div>
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center' }}>

        <Button type="primary" onClick={() => { setIsModalVisible(true); setCurrentItem(null); }}>
          Добавить датчик
        </Button>

        <Button onClick={() => exportToExcel('Sensors_Export')}>
          📁 Экспорт в Excel
        </Button>

        <Input
          placeholder="Поиск…"
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ width: 280 }}
          allowClear
        />

        <Tag className="small-tag">Всего: {totalCount}</Tag>
        <Tag color="blue" className="small-tag">Показано: {shownCount}</Tag>

      </div>

      <SensorsTable data={filtered} onEdit={handleEdit} onDelete={handleDelete} />

      <Modal
        title={currentItem ? 'Редактировать датчик' : 'Добавить датчик'}
        open={isModalVisible}
        onCancel={() => { setIsModalVisible(false); setCurrentItem(null); }}
        footer={null}
        destroyOnHidden
      >
        <SensorForm onAdd={handleAddSensors} initialValues={currentItem} />
      </Modal>
    </div>
  );
};

export default SensorsPage;
